var template = require('@/modules/components/playlist/storybook.handlebars')
const shortVideoTemplate = require('@/modules/components/lora/short-video.handlebars')
import NextIcon from '@/assets/media/icons/next-white.svg'
import PrevIcon from '@/assets/media/icons/prev-white.svg'
import { MIN_INDEX, PAGE_SIZE, PLAYLIST_TYPE, SHORT_VIDEO_TRACKING_TYPE } from '@/configs/constants'
import {
    MAX_RENDER_IN_VIEWPORT,
    STATUS_RESPONSES,
    MANUAL_CART_EVENTS,
    DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
} from '@/configs/settings'
import GlobalSettings from '@/core/global-settings'
import { appendCommonStyling, debounce, initialObserver, isInIframe } from '@/helpers'
import { $videoPlayingIndex } from '~/store/app-context'
import { getPlaylistData, updatePlaylistData } from '~/store/playlist'
import EventManager from '@/core/event-manager'
import { v4 as uuidv4 } from 'uuid'

class LoraStoryBlockPlaylist extends HTMLElement {
    static get observedAttributes() {
        return [
            'current',
            'fullscreen',
            'muted',
            'vertical',
            'pip-style',
            'uuid',
            'enable-fullscreen',
            'fs-force-new-tab',
            'min-h-btns',
        ]
    }
    constructor() {
        super()
        this.attachShadow({ mode: 'open' })
        this.eventManager = new EventManager()
        this.httpInstance = GlobalSettings.httpInstance
        this.handlebarTemplate = template
        this.videos = []
        this.prevIcon = PrevIcon
        this.nextIcon = NextIcon
        this.prevNavBtn = null
        this.nextNavBtn = null
        this.storyBlockComponent = null
        this.listInnerElement = null
        this.listContainer = null
        this.itemElements = []
        this.itemWidth = 200
        this.itemHeight = 480
        this.verticalLayout = false
        this.lastScrollTop = -1
        this.endScroll = false
        this.scrollByClickBtn = false
        this.scrolling = false
        this.startTouchMovePosition = 0
        this.isTouchMove = false
        this.maxScroll = 0
        this.minScroll = 0
        this.distance = 0
        this.params = {
            pageSize: PAGE_SIZE,
            pageNum: 1,
            totalPages: 0,
            isEnded: false,
        }
        this.shortVideoTemplate = shortVideoTemplate
        this.isRendered = true
        this.maxVideos = null
        this.moving = false
        this.movingTimeoutId = null
        this.organizationId = 0
        this.uuid = null
        this.preserveStateToUrl()
        this.customTagName = ''
    }

    getDataAttributes() {
        this.ctaMode = this.getAttribute('cta')
        this.playlistId = this.getAttribute('playlist-id')
        this.enableFullscreen = this.getAttribute('enable-fullscreen') == 'false' ? false : true
        this.gutters = this.getAttribute('gutters') ? parseFloat(this.getAttribute('gutters')) : 0
        this.itemsPerRow = this.getAttribute('item-per-row') ? parseInt(this.getAttribute('item-per-row')) : 5
        this.videoHeight = this.getAttribute('video-height') ? parseFloat(this.getAttribute('video-height')) : 480 // 0 is 100% followed the parent layout
        this.backgroundColor = this.getAttribute('background-color')
            ? this.getAttribute('background-color')
            : 'transparent'
        this.indexCarousel = this.getAttribute('current') ? parseInt(this.getAttribute('current')) : 0
        if (this.verticalLayout) {
            $videoPlayingIndex.setKey(this.playlistId, this.indexCarousel)
        }
        this.isForceNewTab =
            this.hasAttribute('fs-force-new-tab') && this.getAttribute('fs-force-new-tab') !== 'false' ? true : false
        this.pipStyle = this.getAttribute('pip-style') || 'bottom: 0px; right: 15px;'
        this.muted = this.getAttribute('muted') == 'false' ? false : true
        this.wrapper = this.getAttribute('wrapper') ? this.getAttribute('wrapper') : '.lora-story-block'
        this.fullscreenMode = this.getAttribute('fullscreen') !== null ? true : false
        this.loop = this.hasAttribute('loop') && this.getAttribute('loop') !== 'false' ? true : false
        this.verticalLayout =
            this.getAttribute('vertical') !== null && this.getAttribute('vertical') !== 'false' ? true : false

        this.slidesToScroll = 1
        this.autoScale =
            this.getAttribute('auto-scale') !== null && this.getAttribute('auto-scale') !== 'false' ? true : false
        this.maxVideos =
            this.getAttribute('playlist-type') == PLAYLIST_TYPE.GRID && parseInt(this.getAttribute('max-videos'))
        this.uuid = this.getAttribute('uuid') || uuidv4()
        this.playingTime = this.getAttribute('playing-time')
        this.customTagName = this.getAttribute('tag-name') || this.shadowRoot.host.tagName
        this.minVideoHeightToShowButtons = this.getAttribute('min-h-btns') || DEFAULT_MIN_HEIGHT_TO_SHOW_BTN
    }

    async fetchData() {
        if (this.params.isEnded) return
        if (this.httpInstance.repositories) {
            if (this.fullscreenMode && this.isRendered) {
                // Call items from page 1 to page current
                if (this.maxVideos) {
                    this.params.pageSize =
                        Math.ceil((this.indexCarousel + 1) / PAGE_SIZE) * PAGE_SIZE > this.maxVideos
                            ? Number(this.maxVideos)
                            : PAGE_SIZE
                    this.params.isEnded = true
                } else {
                    this.params.pageSize = Math.ceil((this.indexCarousel + 1) / PAGE_SIZE) * PAGE_SIZE
                }

                this.isRendered = false
            }
            let code,
                data = null
            try {
                const playlistData = getPlaylistData(this.playlistId)
                const shouldGetFromCache =
                    this.videos.length === 0 &&
                    this.verticalLayout &&
                    !!playlistData &&
                    (!this.loop || (this.loop && playlistData.isEnded))
                if (shouldGetFromCache) {
                    this.params.pageNum = playlistData.pageNum
                    this.params.pageSize = playlistData.pageSize
                    this.videos = [...playlistData.videos]
                    data = { ...playlistData.data }
                    this.organizationId = data.organizationId
                    this.render()
                    code = STATUS_RESPONSES.SUCCESS
                } else {
                    if (this.loop && this.verticalLayout && !!playlistData) {
                        this.params.pageNum = 1
                        this.params.pageSize = playlistData.data.shortVideos.totalItems
                    }
                    const response = await this.httpInstance.repositories.shortVideo.playlistDetail(
                        this.playlistId,
                        this.params.pageSize,
                        this.params.pageNum
                    )
                    code = response.code
                    data = response.data
                }
                if (code === STATUS_RESPONSES.SUCCESS) {
                    this.organizationId = data.organizationId
                    this.params.pageSize = PAGE_SIZE
                    this.params.totalPages = data.shortVideos.totalPages
                    this.params.pageNum++
                    if (this.params.pageNum > this.params.totalPages || playlistData?.isEnded) {
                        this.params.isEnded = true
                    }
                    data.shortVideos = {
                        ...data.shortVideos,
                        data: data.shortVideos?.data.map((e) => ({
                            ...e,
                            organizationId: this.organizationId,
                            tagName: this.customTagName,
                            pipStyle: this.pipStyle,
                            uuid: this.uuid,
                            enableFullscreen: this.enableFullscreen,
                            minVideoHeightToShowButtons: this.minVideoHeightToShowButtons,
                        })),
                    }
                    const previousPlaylistLength = this.videos.length
                    if (!shouldGetFromCache) {
                        this.videos = [...this.videos, ...data.shortVideos.data]
                        if (this.params.pageNum <= 2) {
                            this.render()
                        } else if (this.params.pageNum > 2) {
                            this.renderMore(previousPlaylistLength, data.shortVideos.data)
                            this.setAttribute('max-index', this.videos.length - 1)
                        }
                    }

                    const videoEmbeds = this.shadowRoot.querySelectorAll('video-embed')
                    // this.videos.forEach((video, index) => {
                    // 	videoEmbeds[index]?.setShortVideoDataFromPlaylist(video);
                    // });

                    // if (!this.fullscreenMode) {
                    //     GlobalSettings.trackingIOT(
                    //         SHORT_VIDEO_TRACKING_TYPE.IMPRESSION,
                    //         this.playlistId,
                    //         data.shortVideos.data,
                    //         this.wrapper,
                    //         data.organizationId
                    //     )
                    // }

                    updatePlaylistData(this.playlistId, {
                        pageSize: this.params.pageSize,
                        pageNum: this.params.pageNum - 1,
                        isEnded: this.params.isEnded,
                        videos: [...this.videos],
                        data: { ...data },
                    })

                    const elementObserver = this.itemElements[this.videos.length - 1]
                    initialObserver(elementObserver, (entries, observer) => {
                        entries.forEach((entry, index) => {
                            if (entry.isIntersecting) {
                                observer.unobserve(elementObserver)
                                this.fetchData()
                            }
                        })
                    })
                }
            } catch (e) {
                console.error(e)
            }
        }
    }

    connectedCallback() {
        this.getDataAttributes()
        this.fetchData()
    }

    disconnectedCallback() {
        this.removeStateFromUrl()
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'current' && oldValue !== newValue && parseInt(newValue) !== this.indexCarousel) {
            let itemWidthOuter = this.itemWidth + 2 * this.gutters
            if (this.verticalLayout) {
                itemWidthOuter = this.itemHeight
            }
            this.moveSlide(itemWidthOuter, parseInt(newValue), true)
        } else if (name === 'fullscreen' && this.itemElements) {
            if (newValue !== null) {
                this.fullscreenMode = true
                this.itemElements.forEach((itemElement) => {
                    itemElement.querySelector('video-embed').setAttribute('fullscreen', '')
                    itemElement.querySelector('video-embed').setAttribute('autoplay', '')
                })

                // this.calculatorItemLayout();
            } else {
                this.fullscreenMode = false
                this.itemElements.forEach((itemElement) => {
                    itemElement.querySelector('video-embed').removeAttribute('fullscreen')
                    itemElement.querySelector('video-embed').removeAttribute('autoplay')
                    itemElement.querySelector('video-embed').setAttribute('no-action-hover', '')
                    itemElement.querySelector('video-embed').setAttribute('muted', this.muted ? 'true' : 'false')
                })
                // this.calculatorItemLayout();
            }
        } else if (name === 'muted') {
            if (newValue == 'false') {
                this.muted = false
            } else {
                this.muted = true
            }
            this.itemElements.forEach((itemElement) => {
                itemElement.querySelector('video-embed').setAttribute('muted', this.muted ? 'true' : 'false')
            })
        } else if (name === 'pip-style' && newValue && oldValue !== newValue) {
            this.itemElements.forEach((itemElement) => {
                itemElement.querySelector('video-embed').setAttribute('pip-style', this.pipStyle)
            })
        } else if (name === 'uuid') {
            this.uuid = newValue
        } else if (name === 'enable-fullscreen') {
            if (newValue !== null && newValue !== 'false') {
                this.enableFullscreen = true
            } else {
                this.enableFullscreen = false
            }
        } else if (name === 'fs-force-new-tab') {
            if (newValue !== null && newValue !== 'false') {
                this.isForceNewTab = true
            } else {
                this.isForceNewTab = false
            }
        } else if (name === 'min-h-btns' && newValue && oldValue !== newValue) {
            this.minVideoHeightToShowButtons = newValue
            this.itemElements.forEach((itemElement) => {
                itemElement.querySelector('video-embed').setAttribute('min-h-btns', newValue)
            })
        } else if (name === 'enable-like-button' && oldValue !== newValue) {
            this.itemElements.forEach((itemElement) => {
                itemElement.querySelector('video-embed').setAttribute('enable-like-button', newValue)
            })
        } else if (name === 'display-like-count' && oldValue !== newValue) {
            this.itemElements.forEach((itemElement) => {
                itemElement.querySelector('video-embed').setAttribute('display-like-count', newValue)
            })
        } else if (name === 'total-like' && oldValue !== newValue) {
            this.itemElements.forEach((itemElement) => {
                itemElement.querySelector('video-embed').setAttribute('total-like', newValue)
            })
        }
    }

    render() {
        if (this.videos.length === 0) return
        var context = {
            startIndex: this.indexCarousel,
            ctaMode: this.ctaMode,
            videos: this.videos,
            gutters: `${this.gutters}px`,
            itemsPerRow: this.itemsPerRow,
            prevIcon: this.prevIcon,
            nextIcon: this.nextIcon,
            fullscreen: this.fullscreenMode,
            wrapper: this.wrapper,
            videoHeight: this.videoHeight ? `${this.videoHeight}px` : '',
            backgroundColor: this.backgroundColor,
            vertical: this.verticalLayout,
            maxVideos: this.maxVideos,
            playingTime: this.playingTime,
            pipStyle: this.pipStyle,
            uuid: this.uuid,
            tagName: this.customTagName,
            organizationId: this.organizationId,
            enableFullscreen: this.enableFullscreen,
            isForceNewTab: this.isForceNewTab,
            minVideoHeightToShowButtons: this.minVideoHeightToShowButtons,
        }
        this.shadowRoot.innerHTML = `${this.handlebarTemplate(context)}`
        this.windowResizeEvent()
        if (!this.fullscreenMode) {
            this.handleInternalEvents()
        }
        this.registerEvents()
        this.calculatorItemLayout()
    }

    handleInternalEvents() {
        window.addEventListener('OPEN_FULLSCREEN', (event) => {
            const { playlistId, videoId, uuid } = event?.detail
            if (this.uuid === uuid) {
                const fullscreenElm = document.querySelector('b-fullscreen')
                this.fullscreenInternalEvents(fullscreenElm)
                this.itemElements.forEach((itemElement) => {
                    let videoEmbed = itemElement.querySelector('video-embed')
                    videoEmbed.setAttribute('disable-tracking', true)
                })
            }
        })
        window.addEventListener('EXIT_FULLSCREEN', (event) => {
            const { playlistId, videoId, uuid } = event?.detail
            if (this.uuid === uuid) {
                this.itemElements.forEach((itemElement) => {
                    let videoEmbed = itemElement.querySelector('video-embed')
                    videoEmbed.setAttribute('disable-tracking', false)
                })
            }
        })
    }

    fullscreenInternalEvents(el) {
        el.eventManager.on(MANUAL_CART_EVENTS.SYNC_PRODUCT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_PRODUCT, data, callback)
        })

        el.eventManager.on(MANUAL_CART_EVENTS.ADD_TO_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.ADD_TO_CART, data, callback)
        })

        el.eventManager.on(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, data, callback)
        })

        el.eventManager.on(MANUAL_CART_EVENTS.SYNC_CART_STATE, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_CART_STATE, data, callback)
        })

        el.eventManager.on(MANUAL_CART_EVENTS.CHECKOUT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.CHECKOUT, data, callback)
        })

        el.eventManager.on('UPDATE_CURRENT_INDEX', (data, callback) => {
            let itemWidthOuter = this.itemWidth + 2 * this.gutters
            this.moveSlide(itemWidthOuter, parseInt(data), true)
        })
    }

    handleEmbedInternalEvents(embed) {
        embed.eventManager.on(MANUAL_CART_EVENTS.SYNC_PRODUCT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_PRODUCT, data, callback)
        })
        embed.eventManager.on(MANUAL_CART_EVENTS.ADD_TO_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.ADD_TO_CART, data, callback)
        })
        embed.eventManager.on(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, data, callback)
        })
        embed.eventManager.on(MANUAL_CART_EVENTS.SYNC_CART_STATE, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_CART_STATE, data, callback)
        })
        embed.eventManager.on(MANUAL_CART_EVENTS.CHECKOUT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.CHECKOUT, data, callback)
        })
    }

    windowResizeEvent() {
        window.addEventListener(
            'resize',
            debounce(() => {
                this.calculatorItemLayout()
            }, 300)
        )
    }

    calculatorItemLayout() {
        if (!this.storyBookRoot) return
        this.listContainer = this.shadowRoot.querySelector('.lora-story-block__list')
        this.listInnerElement = this.shadowRoot.querySelector('.lora-story-block__list-inner')
        let widthListContainer = this.listContainer?.clientWidth // px
        let isHasFsClass = this.shadowRoot.host.classList.contains('lora-fullscreen')
        if (isHasFsClass) this.fullscreenMode = true
        if (this.fullscreenMode) {
            // this.itemWidth =
            // 	(this.storyBookRoot.clientHeight * 9) / 16 - 2 * this.gutters;
            // if (mediaBreakpointDown("xs")) {
            // 	this.itemWidth = window.innerWidth;
            // }
            this.itemWidth = window.innerWidth
        } else {
            let itemPerHeight = this.videoHeight ? this.videoHeight : this.listContainer?.clientHeight | 480
            this.itemWidth = (itemPerHeight * 9) / 16
        }

        if (this.autoScale) {
            if (widthListContainer <= this.itemWidth) {
                this.itemWidth = widthListContainer
            }
        }

        let itemWidthOuter = this.itemWidth + 2 * this.gutters
        this.itemHeight = (itemWidthOuter * 16) / 9
        if (this.verticalLayout) {
            this.itemHeight = this.storyBookRoot.clientHeight
        }
        let listInnerWidth = itemWidthOuter * this.videos.length
        // Set width to list inner, not set when displaying vertical layout
        if (!this.verticalLayout) {
            if (this.listInnerElement) this.listInnerElement.style.width = `${listInnerWidth}px`
        } else {
            if (this.listInnerElement) this.listInnerElement.style.width = `${this.itemWidth}px`
        }
        this.itemElements.forEach((itemElement) => {
            itemElement.style.width = `${this.itemWidth}px`
            let videoEmbed = itemElement.querySelector('video-embed')
            videoEmbed.setAttribute('item-width', this.itemWidth)
            if (!this.fullscreenMode) {
                videoEmbed.setAttribute('video-height', `${this.videoHeight}px`)
            }
        })

        if (this.verticalLayout) {
            itemWidthOuter = this.itemHeight
        }
        if (this.fullscreenMode) {
            this.moveSlide(itemWidthOuter, this.indexCarousel, true, true)
        } else {
            this.moveSlide(itemWidthOuter, this.indexCarousel, true)
        }
        if (this.videos.length > this.slidesToScroll) {
            this.shadowRoot.querySelector('.lora-story-block__nav-next-btn').style.opacity = 1
            this.shadowRoot.querySelector('.lora-story-block__nav-next-btn').style.visibility = 'visible'
        }
    }

    registerEvents() {
        this.storyBlockComponent = this.shadowRoot.querySelector('.lora-story-block')
        this.listContainer = this.shadowRoot.querySelector('.lora-story-block__list')
        this.listInnerElement = this.shadowRoot.querySelector('.lora-story-block__list-inner')
        if (!this.videoHeight && !this.fullscreenMode) {
            this.videoHeight = this.storyBlockComponent.clientHeight - 2 * this.gutters
        }
        this.itemElements = this.shadowRoot.querySelectorAll('.lora-story-block__item')
        this.prevNavBtn = this.shadowRoot.querySelector('.lora-story-block__nav-prev-btn')
        this.nextNavBtn = this.shadowRoot.querySelector('.lora-story-block__nav-next-btn')
        const isMobile =
            window.matchMedia('(any-pointer:coarse)').matches && window.matchMedia('(any-pointer:coarse)').matches

        this.storyBookRoot = this.shadowRoot.querySelector('.lora-story-block')
        this.itemElements.forEach((itemElement) => {
            const videoEmbed = itemElement.querySelector('video-embed')
            this.handleEmbedInternalEvents(videoEmbed)
            itemElement.onclick = (e) => {
                let itemIndex = parseInt(itemElement.getAttribute('data-index'))
                if (itemIndex !== this.indexCarousel) {
                    let itemWidthOuter = this.itemWidth + 2 * this.gutters
                    this.itemHeight = this.storyBookRoot.clientHeight
                    let nextIndexCarousel = itemIndex
                    if (this.verticalLayout) {
                        itemWidthOuter = this.itemHeight
                    }
                    this.moveSlide(itemWidthOuter, nextIndexCarousel, true)
                } else {
                    return
                }
                // else if (isMobile
                // 	&& !this.fullscreenMode && e.target.closest('.lora-video-embed__btn') === null
                // 	&& !e.target.classList.contains('btn')
                // 	&& e.target.tagName.toLowerCase() !== 'button'
                // 	&& e.target.tagName.toLowerCase() !== 'textarea'
                // 	&& e.target.tagName.toLowerCase() !== 'input'
                // 	&& !e.target.classList.contains('lora-poll__content--option')
                // 	&& e.target.closest('.btn') === null
                // 	&& e.target.closest('.lora-video-embed__pausing-overlay') === null) {
                // 	const el = document.createElement('fullscreen-layout')
                // 	el.setAttribute("playlist-id", this.playlistId)
                // 	el.setAttribute("current-index", this.indexCarousel)
                // 	el.setAttribute("loop", this.loop ? "true" : "false")
                // 	document.body.appendChild(el)
                // 	// this.fullscreenMode = true
                // }
            }
        })

        this.prevNavBtn.onclick = (e) => {
            e.preventDefault()
            if (this.scrollByClickBtn) return
            this.scrollByClickBtn = true
            this.goToBackSlide()
        }

        this.nextNavBtn.addEventListener('click', (e) => {
            e.preventDefault()
            if (this.scrollByClickBtn) return
            this.scrollByClickBtn = true
            this.goToNextSlide()
        })

        if (this.params.pageNum > 2) return

        if (this.verticalLayout) {
            this.calculateSwipeDirection(true)
        } else if (!this.verticalLayout && isMobile) {
            this.calculateSwipeDirection(false)
        }

        document.addEventListener('sync-state-poll-qna', (e) => {
            if (this.hasAttribute('fullscreen')) return
            const isMatchingId = (e, id) => e.detail.playlistId === id

            if (e.detail.qa && isMatchingId(e, this.playlistId)) {
                if (e.detail.index != null) {
                    this.itemElements[Number(e.detail.index)]?.children[0].onCheckQaAndUpdate()
                } else {
                    this.itemElements.forEach((itemElement) => {
                        if (itemElement.children[0].videoId == e.detail.id) {
                            itemElement.children[0].onCheckQaAndUpdate(e.detail.qa.answer)
                        }
                    })
                }
            } else if (e.detail.poll && isMatchingId(e, this.playlistId)) {
                if (e.detail.index != null) {
                    this.itemElements[Number(e.detail.index)]?.children[0].onCheckPollAndUpdate()
                } else {
                    this.itemElements.forEach((itemElement) => {
                        if (itemElement.children[0].videoId == e.detail.id) {
                            itemElement.children[0].onCheckPollAndUpdate()
                        }
                    })
                }
            }
        })
    }
    calculateSwipeDirection(isVertical = false) {
        let startY = 0
        let startX = 0
        let endY = 0
        let endX = 0
        let that = this
        this.listContainer.addEventListener('touchstart', function (event) {
            startX = event.touches[0].clientX
            startY = event.touches[0].clientY
        })
        this.listContainer.addEventListener('touchend', (event) => {
            endX = event.changedTouches[0].clientX
            endY = event.changedTouches[0].clientY

            const MINIMUM_PIXELS_SCROLL = 20
            const distance = isVertical ? Math.abs(endY - startY) : Math.abs(endX - startX)
            const isUpWards = isVertical ? endY < startY : endX < startX

            if (distance < MINIMUM_PIXELS_SCROLL) return
            isUpWards ? that.goToNextSlide() : that.goToBackSlide()
        })
    }

    checkSwipeDirection(deltaY) {
        if (deltaY > 0) {
            this.maxScroll = Math.max(this.maxScroll, deltaY)
        } else if (deltaY < 0) {
            this.minScroll = Math.min(this.minScroll, deltaY)
        }
        // Clear our timeout throughout the scroll
        window.clearTimeout(this.scrolling)
        // Set a timeout to run after scrolling ends
        this.scrolling = setTimeout(() => {
            // Run the callback
            this.autoMoveToSlide(deltaY)
            this.maxScroll = 0
            this.minScroll = 0
        }, 66)
    }

    autoMoveToSlide(scrollDirection) {
        if (scrollDirection > 0 && this.maxScroll >= 20) {
            this.goToNextSlide()
        } else if (scrollDirection < 0 && this.minScroll <= -20) {
            this.goToBackSlide()
        }
    }

    goToBackSlide() {
        let itemWidthOuter = this.itemWidth + 2 * this.gutters
        if (this.verticalLayout) {
            itemWidthOuter = this.itemHeight
        }
        let nextIndexCarousel
        let lengthItems = this.videos.length
        nextIndexCarousel = this.indexCarousel - this.slidesToScroll
        if (nextIndexCarousel <= 0) {
            if (this.loop && !this.indexCarousel) {
                nextIndexCarousel = lengthItems - this.slidesToScroll
            } else {
                nextIndexCarousel = 0
            }
        }
        if (!this.loop && !this.indexCarousel) {
            return
        }
        this.moveSlide(itemWidthOuter, nextIndexCarousel, true)
    }

    goToNextSlide() {
        let itemWidthOuter = this.itemWidth + 2 * this.gutters
        if (this.verticalLayout) {
            itemWidthOuter = this.itemHeight
        }
        let nextIndexCarousel
        let lengthItems = this.videos.length
        nextIndexCarousel = this.indexCarousel + this.slidesToScroll
        if (nextIndexCarousel >= lengthItems) {
            if (this.loop) {
                nextIndexCarousel = 0
            } else {
                nextIndexCarousel = lengthItems - 1
            }
        }
        if (!this.loop && nextIndexCarousel - this.slidesToScroll >= this.videos.length - 1) {
            return
        }
        this.moveSlide(itemWidthOuter, nextIndexCarousel, true)
    }

    moveSlide(itemWidthOuter, nextIndexCarousel, autoplay = false, isForced = false) {
        if (isNaN(itemWidthOuter)) return
        if (!this.clickedBtnTimeoutId) {
            this.clickedBtnTimeoutId = setTimeout(() => {
                this.scrollByClickBtn = false
                clearTimeout(this.clickedBtnTimeoutId)
                this.clickedBtnTimeoutId = null
            }, 500)
        }
        if (!this.movingTimeoutId) {
            this.movingTimeoutId = setTimeout(() => {
                clearTimeout(this.movingTimeoutId)
                this.moving = false
                this.movingTimeoutId = null
            }, 800)
        }
        if (!this.listContainer || this.moving) {
            return
        }
        this.moving = true
        let lengthItems = this.videos.length

        // Apply transition animation for if next index item is 1
        const isTransition =
            (Math.abs(nextIndexCarousel - this.indexCarousel) === 1 ||
                Math.abs(nextIndexCarousel - this.indexCarousel) === 0) &&
            this.verticalLayout

        this.indexCarousel = nextIndexCarousel
        $videoPlayingIndex.setKey(this.playlistId, this.indexCarousel)

        let prevIndex = this.indexCarousel - 1
        let nextIndex = this.indexCarousel + 1
        if (this.loop) {
            if (prevIndex < 0) {
                prevIndex = lengthItems - 1
            }
            if (nextIndex > lengthItems - 1) {
                nextIndex = 0
            }
        }

        if ((!this.loop && !this.indexCarousel) || lengthItems <= 1) {
            this.prevNavBtn.style.opacity = 0
            this.prevNavBtn.style.visibility = 'hidden'
        } else {
            this.prevNavBtn.style.opacity = 1
            this.prevNavBtn.style.visibility = 'visible'
        }

        let remainingItems = lengthItems - this.indexCarousel
        if (
            (!this.loop &&
                this.params.isEnded &&
                (this.indexCarousel >= lengthItems || remainingItems <= this.slidesToScroll)) ||
            lengthItems <= 1
        ) {
            this.nextNavBtn.style.opacity = 0
            this.nextNavBtn.style.visibility = 'hidden'
        } else {
            this.nextNavBtn.style.opacity = 1
            this.nextNavBtn.style.visibility = 'visible'
        }

        this.setAttribute('current', this.indexCarousel)
        this.setAttribute('max-index', this.videos.length - 1)
        this.eventManager.emit('UPDATE_CURRENT_INDEX', this.indexCarousel)
        let itemMoveStep = itemWidthOuter / 2
        this.itemElements.forEach((itemElement, index) => {
            let videoComponent = itemElement.querySelector('video-embed')
            let videoElement = videoComponent.shadowRoot.querySelector('.lora-video-embed__video')
            let overlayElement = videoComponent.shadowRoot.querySelector('.lora-video-embed__overlay')
            videoComponent.setAttribute('muted', this.muted ? 'true' : 'false')
            videoComponent.setAttribute('prev-index', prevIndex)
            videoComponent.setAttribute('next-index', nextIndex)
            videoComponent.setAttribute('active-index', this.indexCarousel)

            if (index === this.indexCarousel) {
                if (this.fullscreenMode || autoplay) {
                    videoComponent.setAttribute('autoplay', '')
                    setTimeout(() => {
                        if (videoElement) {
                            videoElement.play()
                        }
                    }, 1000)
                }
                if (!this.fullscreenMode) {
                    videoComponent.setAttribute('loop', '')
                } else {
                    videoComponent.removeAttribute('loop')
                }
                videoComponent.removeAttribute('lazyload')
                videoComponent.removeAttribute('no-action-hover')
                // videoComponent.setAttribute("hide-pause", "")

                if (overlayElement) {
                    overlayElement.style.display = 'flex'
                }
            } else {
                if (index === nextIndex || index === prevIndex) {
                    videoComponent.removeAttribute('lazyload')
                    videoComponent.removeAttribute('no-action-hover')
                }
                videoComponent.removeAttribute('autoplay')
                // videoComponent.removeAttribute("hide-pause")
                videoComponent.setAttribute('no-action-hover', '')
                itemElement.classList.remove('active')
                if (videoElement) {
                    videoElement.pause()
                }
                if (overlayElement) {
                    overlayElement.style.display = 'none'
                }
            }
            if (!this.verticalLayout) {
                let scaleItem = 1 - Math.abs(this.indexCarousel - index) * 0.1
                let translateXItem = (this.indexCarousel - index) * itemMoveStep
                let minDisplayIndex = this.indexCarousel - parseInt(this.itemsPerRow / 2)
                let maxDisplayIndex = this.indexCarousel + parseInt(this.itemsPerRow / 2)
                let displayState = index < minDisplayIndex || index > maxDisplayIndex ? 'hidden' : 'visible'
                let zIndexItem =
                    index === this.indexCarousel
                        ? 3
                        : index === this.indexCarousel - 1 || index === this.indexCarousel + 1
                        ? 2
                        : index === this.indexCarousel - 2 || index === this.indexCarousel + 2
                        ? 1
                        : 0
                // scale(0.8) translateX(350px)
                itemElement.style.transform = `scale(${scaleItem}) translateX(${translateXItem}px)`
                itemElement.style.visibility = displayState
                itemElement.style.opacity = displayState === 'hidden' ? 0 : 1
                itemElement.style.zIndex = zIndexItem
                itemElement.style.filter =
                    index === this.indexCarousel ? 'brightness(1) blur(0)' : 'brightness(0.8) blur(5px)'
                itemElement.style.pointerEvents = index === this.indexCarousel ? 'auto' : 'none'
            }
        })
        if (!this.verticalLayout) {
            let translateXList = this.listContainer.clientWidth / 2 - (2 * this.indexCarousel + 1) * itemMoveStep
            this.listInnerElement.style.transform = `translateX(${translateXList}px)`
        } else {
            let translateYList = this.itemHeight * nextIndexCarousel
            if (!isTransition) {
                let distanceTranslateY = translateYList + this.itemHeight
                // Translate from first item to last item
                if (nextIndexCarousel > 1) {
                    this.listInnerElement.style.transform = `translateY(-${distanceTranslateY}px)`
                    // Translate from last item to first item
                } else if (nextIndexCarousel === 0) {
                    this.listInnerElement.style.transform = `translateY(${distanceTranslateY}px)`
                }
                this.listInnerElement.style.transition = `none`
                requestAnimationFrame(() => {
                    this.listInnerElement.style.transition = `all 1000ms cubic-bezier(0.25, 0.1, 0.25, 1)`
                    this.listInnerElement.style.transform = `translateY(-${translateYList}px)`
                })
            } else {
                this.listInnerElement.style.transform = `translateY(-${translateYList}px)`
            }

            if (isForced) {
                this.listInnerElement.style.transition = `none`
            } else {
                this.listInnerElement.style.transition = isTransition
                    ? `all 1000ms cubic-bezier(0.25, 0.1, 0.25, 1)`
                    : `none`
            }
        }
        this.preserveStateToUrl()
    }

    preserveStateToUrl() {
        if (!this.fullscreenMode || !isInIframe()) return
        const url = new URL(window.location.href)
        url.searchParams.set('playlistId', this.playlistId)
        url.searchParams.set('current', this.indexCarousel)
        if (this.loop) url.searchParams.set('loop', 'true')
        window.history.replaceState({}, '', url)
    }

    removeStateFromUrl() {
        if (!this.fullscreenMode || !isInIframe()) return
        const url = new URL(window.location.href)
        url.searchParams.delete('playlistId')
        url.searchParams.delete('current')
        url.searchParams.delete('loop')
        window.history.replaceState({}, '', url)
    }

    renderMore(previousPlaylistLength, videos) {
        const innerList = this.shadowRoot.querySelector('.lora-story-block__list-inner')
        if (!innerList) return
        this.prevNavBtn.style.opacity = 0
        this.prevNavBtn.style.visibility = 'hidden'
        this.nextNavBtn.style.opacity = 0
        this.nextNavBtn.style.visibility = 'hidden'
        videos.forEach((v, index) => {
            const context = {
                ...v,
                videoId: v.id,
                videoType: v.overlayType,
            }
            const realIndex = previousPlaylistLength + index
            const wrapperCarouselItem = document.createElement('div')
            wrapperCarouselItem.classList = 'lora-story-block__item'
            wrapperCarouselItem.setAttribute('data-index', realIndex)

            const carouselItem = document.createElement('video-embed')
            carouselItem.classList = 'lora-story-block__video-embed'
            carouselItem.setAttribute('video-id', v.id)
            carouselItem.setAttribute('title', v.title)
            carouselItem.setAttribute('data-index', realIndex)
            carouselItem.setAttribute('group', '')
            carouselItem.setAttribute('gutters', '')
            carouselItem.setAttribute('lazyload', '')
            carouselItem.setAttribute('cta', '')
            carouselItem.setAttribute('wrapper', 'lora-story-block-playlist')
            carouselItem.setAttribute('thumbnail', v.thumbnail)
            carouselItem.setAttribute('story', '')
            carouselItem.setAttribute('static-height', '')
            carouselItem.setAttribute('no-action-hover', '')
            carouselItem.setAttribute('pip-style', v?.pipStyle)
            carouselItem.setAttribute('tag-name', v?.tagName)
            carouselItem.setAttribute('organization-id', v?.organizationId)
            carouselItem.setAttribute('uuid', v?.uuid)
            carouselItem.setAttribute('enable-fullscreen', v?.enableFullscreen)
            carouselItem.setAttribute('min-h-btns', v?.minVideoHeightToShowButtons)
            carouselItem.setAttribute('enable-like-button', v?.enableLikeButton)
            carouselItem.setAttribute('display-like-count', v?.displayLikeCount)
            carouselItem.setAttribute('total-like', v?.totalLike)
            carouselItem.setAttribute('video-type', v?.overlayType)
            if (this.fullscreenMode) {
                carouselItem.setAttribute('fullscreen', '')
            }
            carouselItem.innerHTML = `${this.shortVideoTemplate(context)}`
            wrapperCarouselItem.appendChild(carouselItem)
            wrapperCarouselItem.style.width = `${this.itemWidth}px`
            carouselItem.setAttribute('item-width', this.itemWidth)
            if (!this.fullscreenMode) {
                carouselItem.setAttribute('video-height', `${this.videoHeight}px`)
            }
            let itemWidthOuter = this.itemWidth + 2 * this.gutters
            if (!this.verticalLayout) {
                let scaleItem = 1 - Math.abs(this.indexCarousel - realIndex) * 0.1
                let itemMoveStep = itemWidthOuter / 2
                let translateXItem = (this.indexCarousel - realIndex) * itemMoveStep
                let minDisplayIndex = this.indexCarousel - parseInt(this.itemsPerRow / 2)
                let maxDisplayIndex = this.indexCarousel + parseInt(this.itemsPerRow / 2)
                let displayState = realIndex < minDisplayIndex || realIndex > maxDisplayIndex ? 'hidden' : 'visible'
                let zIndexItem =
                    realIndex === this.indexCarousel
                        ? 3
                        : realIndex === this.indexCarousel - 1 || realIndex === this.indexCarousel + 1
                        ? 2
                        : realIndex === this.indexCarousel - 2 || realIndex === this.indexCarousel + 2
                        ? 1
                        : 0
                wrapperCarouselItem.style.transform = `scale(${scaleItem}) translateX(${translateXItem}px)`
                wrapperCarouselItem.style.visibility = displayState
                wrapperCarouselItem.style.opacity = displayState === 'hidden' ? 0 : 1
                wrapperCarouselItem.style.zIndex = zIndexItem
                wrapperCarouselItem.style.filter =
                    realIndex === this.indexCarousel ? 'brightness(1) blur(0)' : 'brightness(0.8) blur(5px)'
                wrapperCarouselItem.style.pointerEvents = realIndex === this.indexCarousel ? 'auto' : 'none'
            }

            innerList.appendChild(wrapperCarouselItem)
            let listInnerWidth = 0
            if (!this.verticalLayout) {
                listInnerWidth = itemWidthOuter * this.videos.length
                // Set width to list inner, not set when displaying vertical layout
                this.listInnerElement.style.transition = 'none'
            }
            if (!this.verticalLayout) {
                window.requestAnimationFrame(() => {
                    if (this.listInnerElement) this.listInnerElement.style.width = `${listInnerWidth}px`
                })
            }
        })
        this.itemElements = this.shadowRoot.querySelectorAll('.lora-story-block__item')
        window.requestAnimationFrame(() => {
            if (!this.verticalLayout) {
                this.listInnerElement.style.transition = '1s ease all'
            }
            this.prevNavBtn.style.opacity = 1
            this.prevNavBtn.style.visibility = 'visible'
            this.nextNavBtn.style.opacity = 1
            this.nextNavBtn.style.visibility = 'visible'
        })
    }
}
window.customElements.define('story-block-playlist', LoraStoryBlockPlaylist)
